<form autocomplete="off" class="p-0" novalidate [formGroup]="photoSignDetailsForm">
    <div class="col-lg-12 col-md-12">
        <!-- <div class="card custom-card "> -->
        <div class="mt-3">
            <div>
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/image-gallery.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Photo & Signature</b></h3>
            </div>
            <div class="row clearfix">
                <div class="col-sm-3">
                    <div class="col-sm-12">
                        <div class="form-group ">
                            <mat-label> Upload Photo :</mat-label>
                        </div>
                    </div>
                    <div class="col-sm-12 bg-secondary rounded-3 p-1 pb-4 mb-4">


                        <div class="col-sm-12 " formControlName="StuPhoto">
                            <img *ngIf="!userImage" class=" img2 frame" src="../../assets/images/user2.png"
                                alt="Amanda Wilson" width="500rem"><!--rounded-circle-->
                            <img *ngIf="userImage" class=" img2 frame" [src]="userImage" alt="patient photo"
                                width="500rem"><!--rounded-circle-->
                            <!-- <button class="btn btn-light shadow btn-sm mb-2" type="button"><i class="ai-refresh-cw me-2"></i>Change avatar</button> -->

                        </div>

                        <div class="col-sm-12 btnpossition ">

                            <input #fileUpload type="file" style="display: none;" (change)="onChange1($event)" />
                            <button type="button" class="btn btn-light shadow btn-sm m-0 example-full-width mt-3"
                                matTooltip="Upload JPG, GIF or PNG image.300 x 300 required."
                                (click)="fileUpload.click()"><i class="ai-refresh-cw me-2"></i>Upload Photo</button>


                        </div>

                    </div>
                    <mat-error class="margin_tp"
                        *ngIf="photoSignDetailsForm.controls['StuPhoto'].touched && photoSignDetailsForm.controls['StuPhoto'].errors?.required">
                        Mandatory
                    </mat-error>
                    <div class="col-sm-12">
                        <h6 class="mb-1 redCol"><b>
                                Upload profile picture & signature less than 500KB...!</b></h6>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12">
                        <div class="form-group ">
                            <mat-label> Upload Signature :</mat-label>
                        </div>
                    </div>
                    <div class="col-sm-12 bg-secondary rounded-3 p-1 pb-4 mb-4">


                        <div class="col-sm-12" formControlName="StuSignature">
                            <img *ngIf="!signatureImage" class=" img2 frame" src="../../assets/images/sign.png"
                                alt="Amanda Wilson" width="500rem"><!--rounded-circle-->
                            <img *ngIf="signatureImage" class=" img2 frame" [src]="signatureImage" alt="patient photo"
                                width="500rem"><!--rounded-circle-->
                            <!-- <button class="btn btn-light shadow btn-sm mb-2" type="button"><i class="ai-refresh-cw me-2"></i>Change avatar</button> -->

                        </div>



                        <div class="col-sm-12 btnpossition ">
                            <!-- <input #fileUpload type="file" (change)="onChange($event)" /> -->

                            <input #fileUpload2 type="file" style="display: none;" (change)="onChangeSign($event)" />
                            <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                                [aspectRatio]="4 / 3" format="png" (imageCropped)="imageCropped($event)"
                                (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
                                (loadImageFailed)="loadImageFailed()"></image-cropper>
                                <img [src]="croppedImage" />
                            <button type="button" class="btn btn-light shadow btn-sm m-0 example-full-width mt-3"
                                matTooltip="Upload JPG, GIF or PNG image.300 x 300 required."
                                (click)="fileUpload2.click()"><i class="ai-refresh-cw me-2 mb-5"></i>Upload
                                Sign</button>


                        </div>

                    </div>
                    <mat-error class="margin_tp"
                        *ngIf="photoSignDetailsForm.controls['StuSignature'].touched && photoSignDetailsForm.controls['StuSignature'].errors?.required">
                        Mandatory
                    </mat-error>
                </div>



                <!-- <div class="col-sm-12">
                        <button type="button"
                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                            *ngIf="submitButton" (click)="save()">Save and Continue</button>
                            <button [disabled]="disabled" type="button"
                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                            *ngIf="updateButton" (click)="update()">Update and Continue</button>
                           <button type="button" (click)="back()"
                            class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                            >Back</button>
                       
                    </div> -->
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="updateButton" [disabled]="disabled || isSaving"
                            (click)="updateCheck()" class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" *ngIf="submitButton"
                            class="btn btn-primary btn-icon-text fr sz floatright mt-1" [disabled]="isSaving"
                            (click)="submitCheck()">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn btn-primary btn-icon-text floatright fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>

                </div>
            </div>

        </div>
        <!-- </div> -->
    </div>
</form>